import Avatar from "../components/Avatar";
import { Activity, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { dashboardApi } from "../api";
import { TableSkeleton, useSlowEnoughToShow } from "../components/Skeleton";
import type { ActivityItem } from "../types";
import { formatDate } from "../utils";

function actionLabel(action: string) {
  return action.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}

export default function ActivityPage() {
  const [activity, setActivity] = useState<ActivityItem[]>([]);
  const [loading, setLoading] = useState(true);
  const showSkeleton = useSlowEnoughToShow(loading);

  async function load() {
    setLoading(true);
    try {
      setActivity((await dashboardApi.activity()).activity);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Could not load the activity log.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  return (
    <div className="page-stack">
      <section className="activity-intro">
        <div><span className="section-eyebrow">Audit trail</span><h2>Account actions and changes</h2><p>Review sign-ins, requests, approvals, completed work, and balance changes.</p></div>
        <button className="button button-secondary" onClick={() => void load()} disabled={loading}><RefreshCw size={17} className={loading ? "spin" : ""} /> Refresh</button>
      </section>
      <section className="panel activity-panel">
        {activity.length ? <div className="activity-list">{activity.map((item) => <article className="activity-row" key={item.id}>
              <Avatar name={item.user_name || null} />
              <div>
                <div><strong>{actionLabel(item.action)}</strong><span>{formatDate(item.created_at, true)}</span></div>
                <p>{item.detail}</p>
                {/* The name leads now rather than trailing as a footnote — this log
                    is a record of people, and reads like one. */}
                <small>{item.user_name || "Automatic"}{item.via ? ` via ${item.via}` : ""}</small>
              </div>
            </article>)}</div>
          : loading
            ? (showSkeleton ? <TableSkeleton rows={5} label="Loading the activity log" /> : null)
            : <div className="empty-state"><Activity size={30} /><h4>No activity recorded</h4><p>Account actions will appear here.</p></div>}
      </section>
    </div>
  );
}
